import { Injectable, signal } from '@angular/core';

export interface Breadcrumb {
  label: string;
  url: string;
}

@Injectable({ providedIn: 'root' })
export class BreadcrumbService {
  readonly breadcrumbs = signal<Breadcrumb[]>([]);

  setBreadcrumbs(crumbs: Breadcrumb[]): void {
    this.breadcrumbs.set(crumbs);
  }
}
